/**
 * @file CustomIcon.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @description Custom SVG icons for invoicing (I) and bills (B) based on Illustrator receipt_long artwork
 * @created 2026-03-12
 * @modified 2026-03-12
 */

import React from 'react';

// Shared receipt body path (Adobe Illustrator export, 24x24 viewBox)
const RECEIPT_BODY = "M6,22c-.83,0-1.54-.29-2.13-.88-.58-.58-.88-1.29-.88-2.13v-2c0-.28.1-.52.29-.71.19-.19.43-.29.71-.29h2V2.6c0-.12.05-.2.15-.24s.19-.02.28.06l.73.73c.1.1.22.15.35.15s.25-.05.35-.15l.8-.8c.1-.1.22-.15.35-.15s.25.05.35.15l.8.8c.1.1.22.15.35.15s.25-.05.35-.15l.8-.8c.1-.1.22-.15.35-.15s.25.05.35.15l.8.8c.1.1.22.15.35.15s.25-.05.35-.15l.8-.8c.1-.1.22-.15.35-.15s.25.05.35.15l.8.8c.1.1.22.15.35.15s.25-.05.35-.15l.8-.8c.1-.1.22-.15.35-.15s.25.05.35.15l.8.8c.1.1.22.15.35.15s.25-.05.35-.15l.73-.73c.08-.08.18-.1.28-.06s.15.12.15.24v16.4c0,.83-.29,1.54-.88,2.13-.58.58-1.29.88-2.13.88H6ZM18,20c.28,0,.52-.1.71-.29s.29-.43.29-.71V5h-11v11h8c.28,0,.52.1.71.29s.29.43.29.71v2c0,.28.1.52.29.71s.43.29.71.29Z";

const ICONS = {
  'receipt-invoice': (
    <g fill="currentColor">
      <path d={RECEIPT_BODY}/>
      <path d="M14.34,14.67h-1.76V6.14h1.76v8.53Z"/>
    </g>
  ),
  'receipt-bill': (
    <g fill="currentColor">
      <path d={RECEIPT_BODY}/>
      <path d="M10.34,14.81V6.28h2.99c1.04,0,1.82.2,2.36.59s.8.98.8,1.74c0,.42-.11.79-.32,1.1s-.51.55-.9.7c.44.11.78.33,1.03.66s.38.74.38,1.22c0,.82-.26,1.44-.79,1.86s-1.27.64-2.24.64h-3.32ZM12.1,9.85h1.3c.89-.02,1.33-.37,1.33-1.06,0-.39-.11-.67-.34-.83s-.58-.25-1.06-.25h-1.23v2.15ZM12.1,11.09v2.3h1.51c.41,0,.74-.1.97-.3s.35-.47.35-.82c0-.78-.4-1.18-1.21-1.19h-1.61Z"/>
    </g>
  )
};

/**
 * Renders a custom SVG icon that inherits the parent's color via currentColor.
 * Drop-in replacement for <span className="material-symbols-rounded">receipt_long</span>
 *
 * Usage:
 *   <CustomIcon name="receipt-invoice" />
 *   <CustomIcon name="receipt-bill" style={{ color: '#2e7d32' }} title="Invoiced" />
 *   <CustomIcon name="receipt-invoice" size={20} />
 */
function CustomIcon({ name, size = 24, className = '', style, title }) {
  const paths = ICONS[name];
  if (!paths) return null;

  return (
    <svg
      className={`custom-icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      style={style}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
    >
      {title && <title>{title}</title>}
      {paths}
    </svg>
  );
}

export default CustomIcon;
